'use strict';

const accordion = {
	buttons : document.getElementsByClassName('accordion-toggle'),
	init: function() {
		for(const button of this.buttons) {
			const accordionId = button.dataset.accordionId;
			if( accordionId ){
				const toggleHeight = document.getElementsByClassName("toggleHeight-"+accordionId);
				const toggleClass = document.getElementsByClassName("toggleClass-"+accordionId);
				if( toggleHeight || toggleClass ){
					button.addEventListener('click', e => {

						button.classList.toggle('active')
						button.blur();
						if(toggleClass){
							for(const toggleClassItem of toggleClass){
								toggleClassItem.classList.toggle('active');
							}
						}
						if(toggleHeight){
							for(const toggleHeightItem of toggleHeight){
								toggleHeightItem.classList.toggle('active');
								toggleHeightItem.style.maxHeight = (toggleHeightItem.classList.contains('active') ? toggleHeightItem.scrollHeight : 0) + "px";
							}
						}

					})
				}
			}
		}
	},
}

window.addEventListener('DOMContentLoaded', function() {
	if(accordion.buttons) {
		accordion.init();
	}
});